const filter = {
    filter: {
        CLINICAL: 'Clinical evidence',
        PRECLINICAL: 'Preclinical evidence',
        IN_SILICO: 'In-silico evidence',
        MATCH_TUMOR: "Patient's tumor type",
        MATCH_PROFILE: "Patient's exact alterations",
        addFilter: 'Add Filter',
        addFilterEvidence: 'Filter',
        THIS_TUMOR_TYPE: 'This tumor type',
        OTHER_TUMOR_TYPE: 'Other tumor types',
        DEVELOPMENT: 'Development',
        clearAll: 'Clear all',
        inputPlaceholder: 'Search for a Compound by name',
        or: 'OR',
        negative: 'Negative GDS',
        positive: 'Positive GDS'
    },
    filterTooltip: {
        CLINICAL:
            'Show evidence from clinical studies and trials involving human subjects',
        PRECLINICAL: 'Show evidence from laboratory studies and animal models',
        IN_SILICO:
            'Show evidence from computational models or bioinformatic predictions',
        MATCH_TUMOR:
            'Show evidence specific to the patient’s diagnosed tumor type',
        MATCH_PROFILE:
            'Show only evidence related to the patient’s specific molecular alterations (e.g. KRAS G12D), excluding broader gene-level evidence (e.g. KRAS-mutant).'
    }
}

export default filter
